import ManaParticle from "../../../ManaParticle"
import ManaZoneNode, { ManaZoneNodeOptions } from "../../ManaZoneNode"
import NodeCategories from "../../NodeCategories"

export type LoopZoneNodeOptions = { loop?: number } & ManaZoneNodeOptions

export default class LoopZoneNode extends ManaZoneNode {

	static nodeType = 'LoopZoneNode'
	static nodeName = "Loop node"
	static nodeDesc = "Allows the same particle to pass X times"
	static nodeIcon = '➰'
	static category = NodeCategories.Logistics

	loop

	constructor({ loop = 0, ...rest }: LoopZoneNodeOptions) {
		super(rest)

		this.loop = loop
		this.getSymbol()
	}

	setLoop(loop: number) {
		this.loop = loop
		this.reloadSymbol()
	}

	onScroll(dir: number) {
		this.setLoop(Math.max(0, this.loop - dir))
	}

	getSymbol() {
		return LoopZoneNode.nodeIcon + (this.loop || '')
	}

	async act(particle: ManaParticle) {
		const memoryValue = particle.memory[this.uuid]
		const currentLoop = memoryValue === undefined ? 0 : memoryValue
		particle.memory[this.uuid] = (currentLoop + 1)

		return (particle.memory[this.uuid] || 0) < this.loop
	}

	errorParticle(particle: ManaParticle) {
		particle.memory[this.uuid] = 0
		super.errorParticle(particle)
	}

	save() {
		return {
			...super.save(),

			loop: this.loop
		}
	}
}